import { type ExtraValues, type PlatformEvent } from '../types';

// посмотри рекламу в колесе и удвой приз
export const adIsViewedEvent = (extra: ExtraValues): PlatformEvent => {
  return {
    type: 'ad',
    created: Date.now(),
    user_properties: {
      ...(extra && { ...extra.user_properties }),
    },
    event_properties: {
      name: 'view',
      ...extra.event_properties,
    },
  };
};
